module.exports = __webpack_public_path__ + "static/media/thanos-hited.5a178735.png";